const measure = {
  namespaced: true,
  state: {
    isFormSent: false,
  },
  mutations: {
    changeFormStatus(state, status) {
      state.isFormSent = status;
    },
  },
};

export default measure;
